import { EventEmitter, Inject, Injectable, Output } from '@angular/core';
import { NodeResult } from '../../models/net/result/node-result';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppService } from '../../services/app.service';
import { ScrudgService } from '../base/scrudg/scrudg.service';
import { NodeSearchRequest } from '../../models/net/request/node-search-request';
import { ItemEnvelope } from '../../models/net/envelope/base/item-envelope';
import { UpdateResult } from '../../models/net/result/crud/update-result';
import { ScrudgRevisionService } from '../base/scrudg-revision/scrudg-revision.service';
import { NodeFactory } from '../../utilities/node-factory';

@Injectable({
    providedIn: 'root'
})

export class NodesService extends ScrudgRevisionService {

    public currentNodes: NodeResult[] | null = [];
    private coldLoadCompleteSubject = new Subject<void>();
    public coldLoadCompleteObservable = this.coldLoadCompleteSubject.asObservable();

    @Output() navigatedToNode = new EventEmitter<NodeResult>();
    @Output() nodesUpdated = new EventEmitter();

    public constructor(public appService: AppService, public override http: HttpClient, @Inject("API_BASE_URL") apiBaseUrl: string) {

        super(http, apiBaseUrl, "node");

        this.appService.navigatedToRoute.subscribe((route: string) => {

            if (this.currentNodes) {

                let currentNode: NodeResult | null = NodeFactory.getNodeByRoute(route, this.currentNodes);

                if (currentNode != null) {

                    this.navigatedToNode.emit(currentNode);
                }
            }
        });
    }

    public getPublicNodes = (subdomain: string): Observable<NodeResult[] | null> => {

        let result: BehaviorSubject<NodeResult[] | null> = new BehaviorSubject<NodeResult[] | null>(null);
        const apiPath: string = "node/getpublicnodes";
        const fullPath: string = this._apiBaseUrl + apiPath;
        let httpOptions: any = { headers: new HttpHeaders({ "content-type": "application/json" }) };
        let request: NodeSearchRequest = new NodeSearchRequest();

        request.UserId = -1;
        request.Subdomain = subdomain;

        this.http.post<any>(fullPath, request, httpOptions).subscribe((settings: any) => {

            result.next(settings);
            result.complete();

        }, error => {

            result.next(error);
        });

        return result;
    }

    public override search = (request: NodeSearchRequest): Observable<NodeResult[] | null> => {

        let result: any = super.search(request);

        return result;
    }

    public override update = (envelope: ItemEnvelope): Observable<UpdateResult | null> => {

        const result = super.update(envelope);

        this.nodesUpdated.emit();

        return result;
    }

    public notifyColdLoadComplete(): void {

        this.coldLoadCompleteSubject.next();
    }

}
